import Container from '@mui/material/Container'
import Divider from '@mui/material/Divider'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'

import Navbar from '../components/navbar'
import NavbarFooter from '../components/navbar/NavbarFooter'

export default function AboutPage() {
    return (
        <>
            <Navbar />
            <section>
                <main>
                    <Container sx={{ mt: 4, maxWidth: 'md' }}>
                        <Typography variant="h3" gutterBottom>About CrapApp</Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            Ever walked the Vegas Strip trying to figure out which casino won't drain your wallet on the
                            first hand? CrapApp is here for you! We crowdsource minimum bet data from real players so
                            you always know where to find the hottest tables before you even step through the doors.
                        </Typography>

                        <Divider sx={{ my: 3 }} />

                        <Typography variant="h5" sx={{ fontWeight: 'bold' }} gutterBottom>What we offer</Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            Craps, blackjack, roulette, the table game classics. For every Vegas casino on our list,
                            players like you report the minimum bets they actually saw on the floor.
                        </Typography>

                        <Divider sx={{ my: 3 }} />

                        <Typography variant="h5" sx={{ fontWeight: 'bold' }} gutterBottom>Earn points for reporting</Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            Spot a $5 craps table hiding in the back of the Horseshoe? Report it and earn points!
                            The more you contribute, the more the community benefits, and the more your reputation
                            grows as a true Vegas value hunter!
                        </Typography>

                        <Typography variant="body1" sx={{ mb: 4 }}>
                            Minimum bet data is user reported and reflects conditions at the time of the visit.
                            Casinos change their minimums constantly, especially on weekends and during big events.
                            Always verify at the table.
                        </Typography>

                        <Divider sx={{ my: 3 }} />

                        <Typography variant="h5" sx={{ fontWeight: 'bold' }} gutterBottom>Disclaimer &amp; Responsible Gambling Notice</Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            Access to this website is strictly restricted to individuals aged 21 and older.
                            The information provided on this platform is intended solely for entertainment and
                            educational review purposes. This site does not offer real-money gambling services directly.
                        </Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            Gambling involves financial risk and can be addictive. If you or someone you know is
                            struggling with a gambling problem, please seek help immediately. Call{' '}
                            <Link href="tel:1-800-426-2537" underline="hover">1-800-GAMBLER</Link> (US) or visit{' '}
                            <Link href="https://www.gambleaware.org" target="_blank" rel="noopener noreferrer" underline="hover">GambleAware</Link>{' '}
                            for free, confidential support.
                        </Typography>

                        <Typography variant="body1" sx={{ mb: 4 }}>
                            This site is a 100% independent information platform and is not affiliated with,
                            authorized, or endorsed by any casino. All trademarks belong to their respective owners.
                            Ads displayed do not imply endorsement by the brands mentioned.
                        </Typography>
                    </Container>
                </main>
            </section>
            <NavbarFooter />
        </>
    )
}
